export default __webpack_public_path__ + "static/media/logo.544268f4.png";